module.exports = __webpack_public_path__ + "static/media/ils_loan_approve.015ec728.svg";